export function findAirplaneInChangeFlight(flights = []) {
  // Flight that hasn't departed yet and which is after a flight that has already arrived
  for (let i = 1; i < flights.length; i++) {
    const prevArrived = flights[i - 1]?.arrival?.actual;
    const thisDeparted = flights[i]?.departure?.actual;
    if (prevArrived && !thisDeparted) {
      return flights[i];
    }
  }
  return null;
}

export function findAirplaneInRouteFlight(flights = []) {
  /* The first flight that has a location and is "in flight"
   * "in flight" means:
   *  - for 0 <= i <= n-1 -> flight that hasn't arrived
   *  - for i = n         -> flight that hasn't been recovered (but may have arrived)
   */
  return flights?.find(flight => flight?.location && !flight?.arrival?.actual);
}
